import React from 'react';

interface DialogueProps {
    children?: React.ReactNode;
    loading?: boolean;
    error?: string | null;
    skeleton?: React.ReactNode;
    errorTestId?: string;
}

export const Dialogue: React.FC<DialogueProps> = ({ children, loading = false, error, skeleton, errorTestId }) => {
    const content = loading
        ? skeleton
        : error
            ? <p className="text-s text-danger" data-testid={errorTestId}>{error}</p>
            : children;

    // Vertical stack: text, task groups, text, task groups…
    return (
        <div className="flex flex-col gap-m min-w-0 w-full">
            {content}
        </div>
    );
};
